import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-de-aplicacao`

    return {
        index() {
            return repository.get(baseUrl)
        },
        search(queryParms) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}